import { render, staticRenderFns } from "./Filters.vue?vue&type=template&id=4be55442&"
import script from "./Filters.vue?vue&type=script&lang=js&"
export * from "./Filters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4be55442')) {
      api.createRecord('4be55442', component.options)
    } else {
      api.reload('4be55442', component.options)
    }
    module.hot.accept("./Filters.vue?vue&type=template&id=4be55442&", function () {
      api.rerender('4be55442', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/dashboard/Filters.vue"
export default component.exports